import { createIcon } from "@chakra-ui/icons";

export const AdobexdLogo = createIcon({
  displayName: "AdobexdLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M4.042 0h12.916A3.539 3.539 0 0120.5 3.542v12.416a3.539 3.539 0 01-3.542 3.542H4.042A3.539 3.539 0 01.5 15.958V3.542A3.539 3.539 0 014.042 0z"
        fill="#470137"
      />
      <path
        d="M11.017 5.124l-2.5 4.125 2.666 4.375a.143.143 0 01.017.1c-.008.034-.042.009-.092.017H9.2c-.133 0-.225-.008-.283-.092-.175-.35-.359-.691-.534-1.041a33.608 33.608 0 00-.566-1.05c-.2-.359-.4-.717-.6-1.084H7.2c-.175.359-.367.717-.558 1.075-.192.359-.384.717-.567 1.067-.192.35-.383.708-.575 1.05-.033.083-.1.092-.192.092H3.475c-.033 0-.058.016-.058-.025a.116.116 0 01.016-.092l2.592-4.25L3.5 5.116c-.025-.033-.033-.067-.017-.083.017-.025.05-.034.084-.034h1.891c.042 0 .084.009.117.017a.236.236 0 01.083.075c.159.358.342.717.534 1.075.2.358.391.708.6 1.058.2.35.383.7.558 1.059h.017c.175-.367.358-.725.541-1.075.184-.35.375-.7.567-1.05.192-.35.375-.709.558-1.05.009-.034.025-.067.05-.084a.159.159 0 01.109-.016h1.758a.077.077 0 01.091.058c.009.008-.008.042-.024.058zM14.866 13.917a4.144 4.144 0 01-1.791-.375 2.906 2.906 0 01-1.259-1.134c-.308-.508-.458-1.141-.458-1.9a3.423 3.423 0 011.783-3.05c.584-.325 1.284-.483 2.109-.483.041 0 .1 0 .175.008.075.009.158.009.258.017V4.367c0-.059.025-.092.083-.092h1.692c.042-.008.075.025.083.058v7.95c0 .15.009.317.017.5.017.175.025.342.033.484 0 .058-.025.108-.083.133a6.365 6.365 0 01-1.358.4 7.35 7.35 0 01-1.284.117zm.817-1.667V8.583c-.075-.016-.15-.033-.225-.041-.092-.009-.183-.017-.275-.017-.325 0-.65.067-.942.217-.283.141-.525.35-.708.616-.183.267-.275.625-.275 1.059-.008.291.042.583.142.858.083.225.208.425.375.592.158.15.35.266.566.333.225.075.459.108.692.108.125 0 .242-.008.35-.016a.73.73 0 00.3-.042z"
        fill="#FF61F6"
      />
    </g>
  ),
});

export const AtlassianLogo = createIcon({
  displayName: "AtlassianLogo",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        d="M6.427 9.239a.57.57 0 00-.798-.108.591.591 0 00-.167.209l-4.9 9.803a.586.586 0 00.524.847h6.827a.562.562 0 00.523-.324c1.474-3.043.58-7.67-2.01-10.427z"
        fill="#2684FF"
      />
      <path
        d="M10.028.318a12.932 12.932 0 00-.755 12.765l3.292 6.583a.586.586 0 00.523.324h6.826a.583.583 0 00.586-.585c0-.091-.02-.18-.06-.262L11.024.315a.552.552 0 00-.997 0v.003z"
        fill="#2684FF"
      />
    </g>
  ),
});

export const CartIcon = createIcon({
  displayName: "CartIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M7.984 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM17.828 19.937a1.406 1.406 0 100-2.812 1.406 1.406 0 000 2.812zM20.324 5.558a1.051 1.051 0 00-.815-.386H6.134l-.27-1.528a.703.703 0 00-.692-.581H2.359a.703.703 0 000 1.406h2.223L6.59 15.841a.703.703 0 00.692.581h11.25a.703.703 0 100-1.406H7.871l-.248-1.406h10.62a1.057 1.057 0 001.035-.848l1.266-6.328a1.055 1.055 0 00-.22-.876z"
    />
  ),
});

export const ClockIcon = createIcon({
  displayName: "ClockIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <g>
        <rect fill="none" height="24" width="24" />
      </g>
      <g>
        <g>
          <g>
            <path
              fill="currentColor"
              d="M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M16.2,16.2L11,13V7h1.5v5.2l4.5,2.7L16.2,16.2z"
            />
          </g>
        </g>
      </g>
    </g>
  ),
});
export const CreativeTimLogo = createIcon({
  displayName: "CreativeTimLogo",
  viewBox: "0 0 100 100",
  path: (
    <g
      xmlns="http://www.w3.org/2000/svg"
      width="50px"
      height="50px"
      version="1.1"
    >
      <g
        id="logo-creative-tim-black"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="icon"
          transform="translate(15.000000, 19.000000)"
          fill="currentColor"
          fillRule="nonzero"
        >
          <path
            d="M66.4346744,1.49018376e-13 L3.56968951,1.49018376e-13 C1.59820443,1.49018376e-13 -2.98036753e-13,1.59820443 -2.98036753e-13,3.56968951 L-2.98036753e-13,33.5035241 C-2.98036753e-13,35.4750091 1.59820443,37.0732136 3.56968951,37.0732136 L16.4677598,37.0732136 L16.4677598,66.4346744 C16.4666001,67.3810129 16.8417189,68.288989 17.5104719,68.9585615 C18.1792249,69.628134 19.0867408,70.0043639 20.03308,70.0043639 L49.9669146,70.0043639 C51.9383997,70.0043639 53.5366041,68.4061595 53.5366041,66.4346744 L53.5366041,37.0863214 L66.4346744,37.0863214 C67.3810136,37.0863221 68.2885296,36.7100915 68.9572826,36.0405189 C69.6260355,35.3709464 70.0011544,34.4629704 70,33.5166319 L70,3.56968951 C70.0011544,2.62335099 69.6260355,1.71537495 68.9572826,1.04580242 C68.2885296,0.37622988 67.3810136,1.49018376e-13 66.4346744,1.49018376e-13 Z M4.13769396,4.14206323 L32.9311503,4.14206323 L32.9311503,32.9355196 L4.13769396,32.9355196 L4.13769396,4.14206323 Z M49.3989102,65.86667 L20.6054538,65.86667 L20.6054538,37.0863214 L49.3989102,37.0863214 L49.3989102,65.86667 Z M65.8623007,32.9355196 L37.0688443,32.9355196 L37.0688443,4.14206323 L65.8623007,4.14206323 L65.8623007,32.9355196 Z"
            id="Shape"
          />
          <path
            d="M23.6988934,23.3056595 C24.5142794,24.0708897 25.7898859,24.0506562 26.5805917,23.2599503 C27.3712976,22.4692445 27.3915311,21.193638 26.6263009,20.378252 L20.015603,13.767554 C19.2050095,12.9645312 17.8987889,12.9645312 17.0881954,13.767554 L10.4600204,20.378252 C9.90907005,20.8953125 9.68342943,21.6713831 9.87125954,22.4032422 C10.0590897,23.1351013 10.6305787,23.7065903 11.3624377,23.8944204 C12.0942968,24.0822505 12.8703675,23.8566099 13.387428,23.3056595 L18.5344222,18.1586654 L23.6988934,23.3056595 Z"
            id="Path"
          />
          <path
            d="M46.3185783,23.3056595 L51.4655725,18.1586654 L56.6125667,23.3056595 C57.4279526,24.0708897 58.7035592,24.0506562 59.494265,23.2599503 C60.2849709,22.4692445 60.3052044,21.193638 59.5399742,20.378252 L52.9292763,13.767554 C52.1186828,12.9645312 50.8124622,12.9645312 50.0018687,13.767554 L43.3911708,20.378252 C42.6259406,21.193638 42.6461741,22.4692445 43.43688,23.2599503 C44.2275858,24.0506562 45.5031924,24.0708897 46.3185783,23.3056595 L46.3185783,23.3056595 Z"
            id="Path"
          />
          <path
            d="M29.8508185,46.6987044 C29.0342976,45.9346441 27.7586832,45.9567597 26.9691385,46.7486649 C26.1795937,47.54057 26.1612859,48.8162446 26.9277802,49.6304812 L33.5384782,56.2368099 C33.9262423,56.6258256 34.452915,56.8444779 35.002182,56.8444779 C35.5514489,56.8444779 36.0781217,56.6258256 36.4658857,56.2368099 L43.0765837,49.6304812 C43.6002952,49.1075502 43.8052442,48.3449453 43.6142284,47.6299323 C43.4232126,46.9149194 42.8652519,46.3561259 42.1505246,46.1640439 C41.4357974,45.971962 40.6728876,46.1757734 40.1491761,46.6987044 L35.002182,51.8500678 L29.8508185,46.6987044 Z"
            id="Path"
          />
        </g>
      </g>
    </g>
  ),

  //   <chakra.svg
  //   height="50px"
  //   width="50px"
  //   viewBox="0 0 100 100"
  //   fill="none"
  //   xmlns="http://www.w3.org/2000/svg"
  //   color={fill}
  //   {...props}
  // >
  // </chakra.svg>
});

export const CreditIcon = createIcon({
  displayName: "CreditIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M1.406 17.023a2.461 2.461 0 002.461 2.46h14.766a2.461 2.461 0 002.46-2.46v-6.768H1.407v6.768zm2.9-3.34a1.318 1.318 0 011.319-1.318h2.11a1.318 1.318 0 011.318 1.318v.879a1.318 1.318 0 01-1.319 1.318H5.625a1.318 1.318 0 01-1.318-1.318v-.879zM18.633 4.014H3.867a2.46 2.46 0 00-2.46 2.461v1.143h19.687V6.475a2.46 2.46 0 00-2.461-2.46z"
    />
  ),
});

export const DashboardLogo = createIcon({
  displayName: "DashboardLogo",
  viewBox: "0 0 1000 257",
  path: (
    <g width="998" height="257" viewBox="0 0 998 257" fill="none">
      <g clipPath="url(#clip0)">
        <path
          d="M388.5 115.302C406.112 115.302 413.966 126.726 416.584 136.96L441.336 127.916C436.576 109.352 419.44 89.836 388.262 89.836C354.942 89.836 329 115.54 329 151.24C329 186.464 354.942 212.882 388.976 212.882C419.44 212.882 436.814 193.128 442.288 175.04L418.012 166.234C415.394 175.04 407.064 187.654 388.976 187.654C371.602 187.654 356.608 174.564 356.608 151.24C356.608 127.916 371.602 115.302 388.5 115.302Z"
          fill="currentColor"
        />
        <path
          d="M484.894 141.244C485.37 126.488 493.7 115.064 508.932 115.064C526.306 115.064 532.732 126.488 532.732 140.768V209.312H560.34V136.008C560.34 110.542 546.536 90.074 517.976 90.074C505.838 90.074 492.748 94.358 484.894 104.592V37H457.286V209.312H484.894V141.244Z"
          fill="currentColor"
        />
        <path
          d="M577.29 177.896C577.29 196.222 592.284 212.882 616.56 212.882C635.362 212.882 646.786 203.362 652.26 194.556C652.26 203.838 653.212 208.598 653.45 209.312H679.154C678.916 208.122 677.726 201.22 677.726 190.748V133.152C677.726 110.066 664.16 89.836 628.46 89.836C599.9 89.836 581.812 107.686 579.67 127.678L604.898 133.39C606.088 121.728 614.18 112.446 628.698 112.446C643.93 112.446 650.594 120.3 650.594 130.058C650.594 134.104 648.69 137.436 642.026 138.388L612.276 142.91C592.522 145.766 577.29 157.19 577.29 177.896ZM621.796 191.224C610.848 191.224 604.898 184.084 604.898 176.23C604.898 166.71 611.8 161.95 620.368 160.522L650.594 156V161.236C650.594 183.846 637.266 191.224 621.796 191.224Z"
          fill="currentColor"
        />
        <path
          d="M810.108 93.406H773.456L728.95 140.292V37H701.58V209.312H728.95V176.944L743.23 161.95L777.264 209.312H811.06L762.508 142.434L810.108 93.406Z"
          fill="currentColor"
        />
        <path
          d="M889.349 92.692C888.159 92.454 885.303 91.978 881.971 91.978C866.739 91.978 853.887 99.356 848.413 111.97V93.406H821.519V209.312H849.127V154.096C849.127 132.438 858.885 120.062 880.305 120.062C883.161 120.062 886.255 120.3 889.349 120.776V92.692Z"
          fill="currentColor"
        />
        <path
          d="M895.968 177.896C895.968 196.222 910.962 212.882 935.238 212.882C954.04 212.882 965.464 203.362 970.938 194.556C970.938 203.838 971.89 208.598 972.128 209.312H997.832C997.594 208.122 996.404 201.22 996.404 190.748V133.152C996.404 110.066 982.838 89.836 947.138 89.836C918.578 89.836 900.49 107.686 898.348 127.678L923.576 133.39C924.766 121.728 932.858 112.446 947.376 112.446C962.608 112.446 969.272 120.3 969.272 130.058C969.272 134.104 967.368 137.436 960.704 138.388L930.954 142.91C911.2 145.766 895.968 157.19 895.968 177.896ZM940.474 191.224C929.526 191.224 923.576 184.084 923.576 176.23C923.576 166.71 930.478 161.95 939.046 160.522L969.272 156V161.236C969.272 183.846 955.944 191.224 940.474 191.224Z"
          fill="currentColor"
        />
        <rect width="257" height="257" rx="128.5" fill="#4FD1C5" />
        <path
          d="M69.5584 133.985L157.15 46.9959C158.787 45.3708 161.42 47.3484 160.315 49.3729L127.714 109.125C126.987 110.457 127.951 112.083 129.47 112.083H185.809C187.624 112.083 188.501 114.306 187.174 115.545L88.4456 207.687C86.6753 209.339 84.0405 207.011 85.4617 205.051L132.197 140.578C133.156 139.256 132.211 137.404 130.578 137.404H70.9677C69.1826 137.404 68.2917 135.243 69.5584 133.985Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="128.5"
          y1="0"
          x2="128.5"
          y2="257"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7BCBD4" />
          <stop offset="1" stopColor="#29C6B7" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="997.832" height="257" fill="white" />
        </clipPath>
      </defs>
    </g>
  ),
});

export const DashboardLogoWhite = createIcon({
  displayName: "DashboardLogo",
  viewBox: "0 0 163.5 42",
  path: (
    <g fill="none">
      <path
        d="M63.452 19.292c2.877 0 4.16 1.911 4.587 3.623l4.043-1.513c-.777-3.106-3.576-6.371-8.668-6.371-5.443 0-9.68 4.3-9.68 10.274 0 5.893 4.237 10.313 9.796 10.313 4.976 0 7.813-3.305 8.707-6.331l-3.965-1.473c-.427 1.473-1.788 3.583-4.742 3.583-2.837 0-5.286-2.19-5.286-6.092 0-3.903 2.449-6.013 5.208-6.013zM79.196 23.632c.078-2.469 1.438-4.38 3.926-4.38 2.838 0 3.887 1.911 3.887 4.3v11.47h4.51V22.755c0-4.26-2.255-7.685-6.92-7.685-1.982 0-4.12.716-5.403 2.429V6.19h-4.509v28.831h4.51V23.632zM94.287 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.936-1.592 5.83-3.066 0 1.553.156 2.35.195 2.47h4.198c-.039-.2-.233-1.355-.233-3.107v-9.637c0-3.862-2.216-7.247-8.047-7.247-4.664 0-7.619 2.986-7.968 6.332l4.12.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.226.478-5.714 2.39-5.714 5.854zm7.269 2.23c-1.788 0-2.76-1.195-2.76-2.509 0-1.593 1.127-2.39 2.527-2.628l4.936-.757v.876c0 3.783-2.176 5.018-4.703 5.018zM132.312 15.628h-5.986l-7.269 7.845V6.191h-4.47v28.83h4.47v-5.416l2.332-2.508 5.559 7.924h5.52l-7.93-11.19 7.774-8.203zM145.254 15.509a6.3 6.3 0 00-1.205-.12c-2.487 0-4.587 1.235-5.481 3.345v-3.106h-4.392v19.393h4.509v-9.238c0-3.624 1.594-5.695 5.092-5.695.467 0 .972.04 1.477.12v-4.7zM146.335 29.765c0 3.066 2.449 5.853 6.414 5.853 3.071 0 4.937-1.592 5.831-3.066 0 1.553.156 2.35.194 2.47h4.199c-.039-.2-.234-1.355-.234-3.107v-9.637c0-3.862-2.215-7.247-8.046-7.247-4.665 0-7.619 2.986-7.969 6.332l4.121.955c.194-1.951 1.516-3.504 3.887-3.504 2.488 0 3.576 1.314 3.576 2.947 0 .677-.311 1.234-1.399 1.393l-4.859.757c-3.227.478-5.715 2.39-5.715 5.854zm7.269 2.23c-1.788 0-2.759-1.195-2.759-2.509 0-1.593 1.127-2.39 2.526-2.628l4.937-.757v.876c0 3.783-2.177 5.018-4.704 5.018zM41.975 21.5C41.975 9.626 32.578 0 20.987 0 9.398 0 0 9.626 0 21.5S9.396 43 20.988 43c11.59 0 20.987-9.626 20.987-21.5z"
        fill="#fff"
      />
      <path
        d="M11.36 22.418L25.668 7.863c.267-.272.697.06.517.398l-5.325 9.997c-.119.223.039.495.287.495h9.202c.296 0 .44.372.223.58L14.446 34.748c-.29.277-.72-.113-.488-.44l7.633-10.788c.157-.221.003-.531-.264-.531H11.59c-.292 0-.437-.362-.23-.572z"
        fill="#3BCBBE"
      />
    </g>
  ),
});

export const DocumentIcon = createIcon({
  displayName: "DocumentIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M18.809 10.344h-6.153a2.11 2.11 0 01-2.11-2.11V2.083a.176.176 0 00-.175-.176H6.328A2.812 2.812 0 003.516 4.72v14.063a2.812 2.812 0 002.812 2.812h9.844a2.812 2.812 0 002.812-2.813V10.52a.176.176 0 00-.175-.176z"
      />
      <path
        fill="currentColor"
        d="M18.423 8.789l-6.32-6.32a.088.088 0 00-.15.062v5.705a.703.703 0 00.703.703h5.705a.088.088 0 00.062-.15z"
      />
    </g>
  ),
});

export const GlobeIcon = createIcon({
  displayName: "GlobeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109a9.14 9.14 0 100 18.281 9.14 9.14 0 000-18.281z"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109C8.698 2.109 6.3 6.2 6.3 11.249c0 5.048 2.4 9.14 4.951 9.14 2.552 0 4.951-4.092 4.951-9.14 0-5.048-2.399-9.14-4.95-9.14z"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M5.156 5.156C6.836 6.349 8.952 7.06 11.25 7.06c2.298 0 4.414-.711 6.094-1.904M17.344 17.344c-1.68-1.193-3.796-1.904-6.094-1.904-2.298 0-4.413.711-6.094 1.904"
        strokeWidth=".75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        fill="transparent"
        d="M11.25 2.109v18.28M20.39 11.249H2.11"
        strokeWidth=".75"
        strokeMiterlimit="10"
      />
    </g>
  ),
});

export const HelpIcon = createIcon({
  displayName: "HelpIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M11.25 0C5.04 0 0 5.04 0 11.25S5.04 22.5 11.25 22.5 22.5 17.46 22.5 11.25 17.46 0 11.25 0zm-.352 17.813a1.172 1.172 0 110-2.344 1.172 1.172 0 010 2.344zm1.96-5.977c-.95.637-1.08 1.222-1.08 1.758a.82.82 0 11-1.641 0c0-1.284.59-2.305 1.806-3.121 1.13-.758 1.768-1.239 1.768-2.295 0-.718-.41-1.264-1.26-1.668-.199-.095-.644-.187-1.191-.18-.687.008-1.22.172-1.63.503-.775.623-.84 1.302-.84 1.312a.821.821 0 11-1.642-.08c.007-.142.106-1.425 1.452-2.507.698-.562 1.585-.854 2.636-.866.745-.01 1.444.117 1.918.34 1.418.672 2.198 1.79 2.198 3.146 0 1.982-1.325 2.872-2.494 3.658z"
    />
  ),
});

export const HomeIcon = createIcon({
  displayName: "HomeIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M11.494 4.951a.351.351 0 00-.486 0l-8.09 7.729a.352.352 0 00-.109.254v7.254a1.406 1.406 0 001.405 1.406h4.223a.703.703 0 00.704-.703v-5.976a.351.351 0 01.351-.352h3.516a.351.351 0 01.351.352v5.976a.703.703 0 00.704.703h4.22a1.407 1.407 0 001.407-1.406v-7.254a.35.35 0 00-.108-.254L11.494 4.95z"
      />
      <path
        fill="currentColor"
        d="M21.574 11.23l-3.287-3.144V3.314a.703.703 0 00-.703-.703h-2.11a.703.703 0 00-.703.703V4.72l-2.545-2.434c-.239-.24-.593-.378-.976-.378-.38 0-.734.138-.972.379L.93 11.23a.717.717 0 00-.058.983.703.703 0 001.018.046l9.119-8.713a.352.352 0 01.486 0l9.12 8.713a.703.703 0 00.992-.019c.27-.28.248-.74-.033-1.01z"
      />
    </g>
  ),
});

export const InvisionLogo = createIcon({
  displayName: "InvisionLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M18.687 0H2.313A1.813 1.813 0 00.5 1.811v16.374C.5 19.188 1.312 20 2.313 20h16.374a1.813 1.813 0 001.813-1.813V1.812A1.813 1.813 0 0018.687 0z"
        fill="#DC395F"
      />
      <path
        d="M7.184 6.293c.665 0 1.222-.522 1.222-1.204 0-.683-.557-1.204-1.222-1.204-.665 0-1.222.521-1.222 1.204 0 .682.557 1.204 1.222 1.204zM4.65 12.739a4.134 4.134 0 00-.108.905c0 1.06.575 1.764 1.797 1.764 1.013 0 1.834-.602 2.426-1.573l-.361 1.449h2.012l1.15-4.612c.287-1.168.844-1.774 1.689-1.774.665 0 1.078.413 1.078 1.096 0 .197-.018.413-.09.646l-.593 2.12c-.09.306-.126.611-.126.899 0 1.006.593 1.742 1.833 1.742 1.06 0 1.904-.682 2.371-2.317l-.79-.305c-.395 1.095-.737 1.293-1.006 1.293-.27 0-.414-.18-.414-.538 0-.162.037-.342.09-.558l.575-2.065c.144-.485.198-.915.198-1.31 0-1.546-.934-2.352-2.066-2.352-1.06 0-2.138.956-2.677 1.962l.395-1.806H8.962L8.53 8.996h1.438l-.885 3.544c-.695 1.545-1.972 1.57-2.132 1.534-.264-.06-.432-.159-.432-.5 0-.198.036-.482.126-.823l1.348-5.346H4.579l-.431 1.591h1.419L4.65 12.74"
        fill="#fff"
      />
    </g>
  ),
});

export const JiraLogo = createIcon({
  displayName: "JiraLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M20.26 10.42l-8.863-8.93-.86-.865-6.67 6.722L.814 10.42a.827.827 0 000 1.162l6.096 6.14 3.627 3.654 6.67-6.722.105-.104 2.947-2.964a.824.824 0 000-1.166zm-9.722 3.649L7.493 11l3.045-3.068L13.582 11l-3.044 3.068z"
        fill="#2684FF"
      />
      <path
        d="M10.537 7.932a5.184 5.184 0 01-1.502-3.637A5.185 5.185 0 0110.515.65L3.852 7.36l3.626 3.654 3.06-3.082z"
        fill="url(#paint0_linear)"
      />
      <path
        d="M13.59 10.992l-3.053 3.076a5.186 5.186 0 011.502 3.653c0 1.37-.54 2.683-1.502 3.652l6.682-6.728-3.63-3.653z"
        fill="url(#paint1_linear)"
      />
    </g>
  ),
});

export const MastercardIcon = createIcon({
  displayName: "MastercardIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      width="24"
      height="20"
      viewBox="0 0 21 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="6.63158" cy="7.49999" r="6.63158" fill="#EB001B" />
      <circle cx="14.3686" cy="7.49999" r="6.63158" fill="#F79E1B" />
    </svg>
  ),
});

export const PayPalIcon = createIcon({
  displayName: "PayPalIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M16.179 2.532C15.142 1.357 13.265.854 10.863.854H3.895a.997.997 0 00-.986.834L.007 19.945a.595.595 0 00.591.686H4.9l1.08-6.8-.033.215a.993.993 0 01.983-.834h2.044c4.017 0 7.16-1.619 8.08-6.3.027-.14.07-.406.07-.406.262-1.732-.001-2.907-.945-3.974z"
      />
      <path
        fill="currentColor"
        d="M18.213 7.393c-.998 4.61-4.184 7.048-9.24 7.048H7.142L5.773 23.1h2.973a.87.87 0 00.862-.731l.035-.184.684-4.297.044-.237a.87.87 0 01.86-.731h.544c3.514 0 6.264-1.416 7.068-5.51.322-1.644.166-3.021-.63-4.017z"
      />
    </g>
  ),
});

export const PersonIcon = createIcon({
  displayName: "PersonIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M14.618 3.338c-.855-.924-2.05-1.432-3.368-1.432-1.325 0-2.524.505-3.375 1.423-.86.928-1.28 2.188-1.181 3.55.195 2.686 2.239 4.87 4.556 4.87s4.358-2.184 4.556-4.87c.1-1.349-.322-2.607-1.188-3.541zM18.984 21.592H3.515a1.363 1.363 0 01-1.063-.489 1.552 1.552 0 01-.316-1.279c.371-2.058 1.529-3.786 3.348-5 1.616-1.076 3.664-1.67 5.766-1.67s4.15.594 5.765 1.67c1.82 1.214 2.977 2.942 3.348 5 .085.471-.03.937-.315 1.279a1.362 1.362 0 01-1.064.49z"
    />
  ),
});

export const ProfileIcon = createIcon({
  displayName: "ProfileIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path d="M0 0h24v24H0V0z" fill="transparent" />
      <path
        fill="currentColor"
        d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v1c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-1c0-2.66-5.33-4-8-4z"
      />
    </g>
  ),
});

export const RocketIcon = createIcon({
  displayName: "RocketIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M20.99 2.182a.209.209 0 00-.156-.16c-2.574-.63-8.521 1.613-11.743 4.833a13.93 13.93 0 00-1.566 1.85c-.994-.087-1.987-.014-2.834.355-2.39 1.052-3.085 3.796-3.279 4.976a.424.424 0 00.464.492l3.837-.423c.002.29.02.578.052.866.02.2.108.386.25.527l1.486 1.482a.86.86 0 00.528.25c.286.033.573.05.86.053l-.42 3.832a.424.424 0 00.492.464c1.178-.19 3.927-.885 4.972-3.274.37-.847.445-1.836.36-2.824a13.96 13.96 0 001.855-1.567c3.232-3.216 5.462-9.03 4.842-11.732zm-8.067 7.896a2.11 2.11 0 112.983-2.984 2.11 2.11 0 01-2.983 2.984z"
      />
      <path
        fill="currentColor"
        d="M7.4 18.054c-.24.241-.627.335-1.092.416-1.044.178-1.967-.725-1.779-1.78.072-.401.283-.962.415-1.094a.192.192 0 00-.16-.328 2.636 2.636 0 00-1.544.753c-1.033 1.034-1.13 4.87-1.13 4.87s3.838-.097 4.872-1.13c.417-.417.682-.961.752-1.546.017-.184-.207-.293-.334-.16z"
      />
    </g>
  ),
});

export const SettingsIcon = createIcon({
  displayName: "SettingsIcon",
  viewBox: "0 0 24 24",
  // path can also be an array of elements, if you have multiple paths, lines, shapes, etc.
  path: (
    <g>
      <path d="M0,0h24v24H0V0z" fill="none" />
      <path
        fill="currentColor"
        d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"
      />
    </g>
  ),
});

export const SlackLogo = createIcon({
  displayName: "SlackLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)" fillRule="evenodd" clipRule="evenodd">
      <path
        d="M7.832.5c-1.105 0-2 .919-1.999 2.05 0 1.13.895 2.048 2 2.05h2V2.55c.001-1.13-.894-2.048-2-2.05zm0 5.467H2.5c-1.106 0-2.001.918-2 2.05-.002 1.13.894 2.048 2 2.05h5.332c1.106-.001 2.002-.919 2-2.05.002-1.132-.894-2.05-2-2.05z"
        fill="#36C5F0"
      />
      <path
        d="M20.5 8.016c0-1.13-.895-2.048-2-2.05-1.106.002-2.002.92-2 2.05v2.05h2c1.105 0 2-.918 2-2.05zm-5.334 0V2.55c.001-1.13-.893-2.048-2-2.05-1.105 0-2 .919-2 2.05v5.466c-.001 1.131.894 2.049 2 2.05 1.106 0 2.001-.918 2-2.05z"
        fill="#2EB67D"
      />
      <path
        d="M13.166 21c1.106 0 2.001-.919 2-2.05.001-1.13-.894-2.048-2-2.05h-2v2.05c-.001 1.13.894 2.048 2 2.05zm0-5.467h5.333c1.106-.001 2.002-.92 2-2.05.002-1.131-.893-2.049-1.999-2.05h-5.333c-1.106 0-2.001.918-2 2.05-.001 1.13.893 2.049 1.999 2.05z"
        fill="#ECB22E"
      />
      <path
        d="M.5 13.483c-.001 1.13.895 2.049 2 2.05 1.106-.001 2.001-.92 2-2.05v-2.05h-2c-1.105.001-2.001.919-2 2.05zm5.333 0v5.467c-.001 1.13.894 2.048 2 2.05 1.105 0 2-.919 2-2.05v-5.465c.002-1.131-.894-2.05-2-2.05-1.106 0-2 .917-2 2.048z"
        fill="#E01E5A"
      />
    </g>
  ),
});

export const SpotifyLogo = createIcon({
  displayName: "SpotifyLogo",
  viewBox: "0 0 24 24",
  path: (
    <g clipPath="url(#clip0)">
      <path
        d="M10.5 0C4.977 0 .5 4.477.5 10s4.477 10 10 10 10-4.477 10-10c0-5.522-4.477-10-10-10zm4.586 14.422a.623.623 0 01-.857.208c-2.348-1.435-5.304-1.76-8.785-.964a.623.623 0 11-.277-1.216c3.808-.87 7.076-.495 9.712 1.115.294.181.387.564.207.857zm1.223-2.722a.78.78 0 01-1.072.257c-2.687-1.652-6.786-2.13-9.965-1.166a.78.78 0 01-.973-.519.781.781 0 01.52-.972c3.632-1.102 8.147-.569 11.233 1.329a.78.78 0 01.258 1.072zm.106-2.835C13.19 6.95 7.875 6.775 4.797 7.708a.935.935 0 11-.543-1.79c3.533-1.072 9.404-.865 13.115 1.338a.935.935 0 01-.954 1.609z"
        fill="#2EBD59"
      />
    </g>
  ),
});

export const SupportIcon = createIcon({
  // Doesn't display the full icon without w and h being specified
  displayName: "BuildIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M20.885 5.547a.703.703 0 00-1.122-.176l-2.7 2.702a.708.708 0 01-.995 0l-1.167-1.169a.702.702 0 010-.994l2.689-2.69a.704.704 0 00-.21-1.138c-2.031-.908-4.566-.435-6.164 1.152-1.358 1.348-1.763 3.455-1.11 5.78a.698.698 0 01-.197.703L2.593 16.4a2.82 2.82 0 103.981 3.983l6.754-7.332a.699.699 0 01.693-.2 7.885 7.885 0 002.03.279c1.469 0 2.757-.475 3.686-1.39 1.72-1.695 1.983-4.57 1.148-6.192zM4.623 19.901a1.407 1.407 0 11-.305-2.797 1.407 1.407 0 01.305 2.797z"
    />
  ),
});

export const StatsIcon = createIcon({
  displayName: "StatsIcon",
  viewBox: "0 0 24 24",
  path: (
    <path
      fill="currentColor"
      d="M4.57 22.297H3.164a1.055 1.055 0 01-1.055-1.054v-6.328a1.055 1.055 0 011.055-1.055H4.57a1.055 1.055 0 011.055 1.055v6.328a1.055 1.055 0 01-1.055 1.054zM14.414 22.296h-1.406a1.055 1.055 0 01-1.055-1.055V10.695a1.055 1.055 0 011.055-1.055h1.406a1.055 1.055 0 011.055 1.055V21.24a1.055 1.055 0 01-1.055 1.055zM19.336 22.297H17.93a1.055 1.055 0 01-1.055-1.055V5.773A1.055 1.055 0 0117.93 4.72h1.406a1.055 1.055 0 011.055 1.054v15.47a1.055 1.055 0 01-1.055 1.054zM9.492 22.297H8.086a1.055 1.055 0 01-1.055-1.055V2.257a1.055 1.055 0 011.055-1.054h1.406a1.055 1.055 0 011.055 1.054v18.985a1.055 1.055 0 01-1.055 1.055z"
    />
  ),
});

export const WalletIcon = createIcon({
  displayName: "WalletIcon",
  viewBox: "0 0 24 24",
  path: (
    <g>
      <path
        fill="currentColor"
        d="M4.447 4.818h14.062c.164 0 .328.01.491.031a2.9 2.9 0 00-3.406-2.441L4.03 4.382h-.013a2.9 2.9 0 00-1.805 1.149 3.848 3.848 0 012.236-.713zM18.51 5.875H4.446a2.816 2.816 0 00-2.813 2.812v8.438a2.816 2.816 0 002.813 2.812h14.062a2.815 2.815 0 002.813-2.812V8.687a2.815 2.815 0 00-2.813-2.812zm-2.088 8.437a1.406 1.406 0 110-2.811 1.406 1.406 0 010 2.811z"
      />
      <path
        fill="currentColor"
        d="M1.656 11.651V7.28c0-.952.528-2.549 2.358-2.895 1.553-.291 3.091-.291 3.091-.291s1.011.703.176.703-.813 1.077 0 1.077 0 1.032 0 1.032L4.007 10.62l-2.35 1.032z"
      />
    </g>
  ),
});

export const VisaIcon = createIcon({
  displayName: "VisaIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg
      width="26"
      height="20"
      viewBox="0 0 30 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.6708 2.96349C12.6568 4.15055 13.653 4.81298 14.4034 5.20684C15.1744 5.61099 15.4333 5.87013 15.4304 6.23147C15.4245 6.78459 14.8153 7.02862 14.2452 7.03812C13.2505 7.05475 12.6723 6.74889 12.2125 6.51753L11.8542 8.32341C12.3155 8.55247 13.1696 8.75217 14.0554 8.76087C16.1345 8.76087 17.4947 7.65543 17.5021 5.94145C17.5102 3.76625 14.7087 3.64579 14.7278 2.67348C14.7344 2.37871 14.9956 2.06408 15.568 1.98406C15.8512 1.94368 16.6332 1.91274 17.5198 2.35252L17.8677 0.605286C17.391 0.418253 16.7782 0.239136 16.0153 0.239136C14.0583 0.239136 12.6819 1.35962 12.6708 2.96349ZM21.2115 0.389687C20.8319 0.389687 20.5118 0.628245 20.3691 0.99433L17.3991 8.63249H19.4767L19.8901 7.40183H22.429L22.6689 8.63249H24.5L22.9021 0.389687H21.2115ZM21.5021 2.61641L22.1016 5.7116H20.4596L21.5021 2.61641ZM10.1518 0.389687L8.51418 8.63249H10.4939L12.1308 0.389687H10.1518ZM7.22303 0.389687L5.16233 6.00003L4.32878 1.22966C4.23097 0.697187 3.84472 0.389687 3.41579 0.389687H0.0471011L0 0.629037C0.691574 0.790671 1.47729 1.0514 1.95326 1.33033C2.24457 1.50067 2.32775 1.64964 2.42336 2.05458L4.00214 8.63249H6.0945L9.3021 0.389687H7.22303Z"
        fill="#4318FF"
      />
    </svg>
  ),
});

export const StarsIcon = createIcon({
  displayName: "StarIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg 
      width="21" 
      height="22" 
      viewBox="0 0 21 22" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      >
      <path
        d="M17.2996 6.55C17.2163 6.55 17.1454 6.53333 17.0871 6.5C17.0288 6.46667 16.9829 6.40833 16.9496 6.325L16.2246 4.625L14.3996 3.825C14.3163 3.79167 14.2579 3.74583 14.2246 3.6875C14.1913 3.62917 14.1746 3.55833 14.1746 3.475C14.1746 3.39167 14.1913 3.32083 14.2246 3.2625C14.2579 3.20417 14.3163 3.15833 14.3996 3.125L16.2246 2.35L16.9496 0.725C16.9829 0.641667 17.0288 0.583333 17.0871 0.55C17.1454 0.516667 17.2163 0.5 17.2996 0.5C17.3829 0.5 17.4538 0.516667 17.5121 0.55C17.5704 0.583333 17.6163 0.641667 17.6496 0.725L18.3746 2.35L20.1996 3.125C20.2829 3.15833 20.3413 3.20417 20.3746 3.2625C20.4079 3.32083 20.4246 3.39167 20.4246 3.475C20.4246 3.55833 20.4079 3.62917 20.3746 3.6875C20.3413 3.74583 20.2829 3.79167 20.1996 3.825L18.3746 4.625L17.6496 6.325C17.6163 6.40833 17.5704 6.46667 17.5121 6.5C17.4538 6.53333 17.3829 6.55 17.2996 6.55ZM17.2996 21.45C17.2329 21.45 17.1663 21.4333 17.0996 21.4C17.0329 21.3667 16.9829 21.3083 16.9496 21.225L16.2246 19.6L14.4246 18.825C14.3413 18.7917 14.2829 18.7458 14.2496 18.6875C14.2163 18.6292 14.1996 18.5583 14.1996 18.475C14.1996 18.3917 14.2163 18.3208 14.2496 18.2625C14.2829 18.2042 14.3413 18.1583 14.4246 18.125L16.2246 17.35L16.9496 15.625C16.9829 15.5417 17.0288 15.4833 17.0871 15.45C17.1454 15.4167 17.2163 15.4 17.2996 15.4C17.3829 15.4 17.4538 15.4167 17.5121 15.45C17.5704 15.4833 17.6163 15.5417 17.6496 15.625L18.3746 17.35L20.1746 18.125C20.2579 18.1583 20.3163 18.2042 20.3496 18.2625C20.3829 18.3208 20.3996 18.3917 20.3996 18.475C20.3996 18.5583 20.3829 18.6292 20.3496 18.6875C20.3163 18.7458 20.2579 18.7917 20.1746 18.825L18.3746 19.6L17.6496 21.225C17.6163 21.3083 17.5663 21.3667 17.4996 21.4C17.4329 21.4333 17.3663 21.45 17.2996 21.45ZM6.32461 17.125C6.19128 17.125 6.06211 17.0875 5.93711 17.0125C5.81211 16.9375 5.71628 16.8333 5.64961 16.7L4.02461 13.225L0.524609 11.65C0.391276 11.5833 0.287109 11.4875 0.212109 11.3625C0.137109 11.2375 0.0996094 11.1083 0.0996094 10.975C0.0996094 10.8417 0.137109 10.7125 0.212109 10.5875C0.287109 10.4625 0.391276 10.3667 0.524609 10.3L4.02461 8.725L5.64961 5.275C5.71628 5.125 5.81211 5.0125 5.93711 4.9375C6.06211 4.8625 6.19128 4.825 6.32461 4.825C6.45794 4.825 6.58711 4.8625 6.71211 4.9375C6.83711 5.0125 6.93294 5.11667 6.99961 5.25L8.64961 8.725L12.1246 10.3C12.2746 10.3667 12.3871 10.4625 12.4621 10.5875C12.5371 10.7125 12.5746 10.8417 12.5746 10.975C12.5746 11.1083 12.5371 11.2375 12.4621 11.3625C12.3871 11.4875 12.2746 11.5833 12.1246 11.65L8.64961 13.225L6.99961 16.7C6.93294 16.85 6.83711 16.9583 6.71211 17.025C6.58711 17.0917 6.45794 17.125 6.32461 17.125Z" 
        fill="#298BE2"
        />
    </svg>

  )
})

export const GPTversion3Img = createIcon({
  displayName: "GPTversion3Img",
  viewBox: "0 0 24 24",
  path: (
    <svg width="20" height="20" viewBox="0 0 39 39" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="39" height="39" rx="19.5" fill="#E3F2FF"/>
    <path d="M24.6937 16.1205C24.6322 16.1205 24.58 16.1078 24.5369 16.0823C24.4938 16.0569 24.46 16.0123 24.4354 15.9487L23.9004 14.6504L22.5535 14.0394C22.492 14.0139 22.449 13.9789 22.4244 13.9344C22.3998 13.8898 22.3875 13.8357 22.3875 13.7721C22.3875 13.7084 22.3998 13.6543 22.4244 13.6098C22.449 13.5652 22.492 13.5302 22.5535 13.5048L23.9004 12.9129L24.4354 11.6718C24.46 11.6082 24.4938 11.5636 24.5369 11.5382C24.58 11.5127 24.6322 11.5 24.6937 11.5C24.7552 11.5 24.8075 11.5127 24.8506 11.5382C24.8936 11.5636 24.9274 11.6082 24.952 11.6718L25.4871 12.9129L26.8339 13.5048C26.8954 13.5302 26.9385 13.5652 26.9631 13.6098C26.9877 13.6543 27 13.7084 27 13.7721C27 13.8357 26.9877 13.8898 26.9631 13.9344C26.9385 13.9789 26.8954 14.0139 26.8339 14.0394L25.4871 14.6504L24.952 15.9487C24.9274 16.0123 24.8936 16.0569 24.8506 16.0823C24.8075 16.1078 24.7552 16.1205 24.6937 16.1205ZM24.6937 27.5C24.6445 27.5 24.5953 27.4873 24.5461 27.4618C24.4969 27.4364 24.46 27.3918 24.4354 27.3282L23.9004 26.0871L22.572 25.4952C22.5105 25.4698 22.4674 25.4348 22.4428 25.3902C22.4182 25.3457 22.4059 25.2916 22.4059 25.2279C22.4059 25.1643 22.4182 25.1102 22.4428 25.0656C22.4674 25.0211 22.5105 24.9861 22.572 24.9606L23.9004 24.3687L24.4354 23.0513C24.46 22.9877 24.4938 22.9431 24.5369 22.9177C24.58 22.8922 24.6322 22.8795 24.6937 22.8795C24.7552 22.8795 24.8075 22.8922 24.8506 22.9177C24.8936 22.9431 24.9274 22.9877 24.952 23.0513L25.4871 24.3687L26.8155 24.9606C26.877 24.9861 26.92 25.0211 26.9446 25.0656C26.9692 25.1102 26.9815 25.1643 26.9815 25.2279C26.9815 25.2916 26.9692 25.3457 26.9446 25.3902C26.92 25.4348 26.877 25.4698 26.8155 25.4952L25.4871 26.0871L24.952 27.3282C24.9274 27.3918 24.8905 27.4364 24.8413 27.4618C24.7921 27.4873 24.7429 27.5 24.6937 27.5ZM16.5941 24.1969C16.4957 24.1969 16.4004 24.1683 16.3081 24.111C16.2159 24.0537 16.1451 23.9741 16.0959 23.8723L14.8967 21.2184L12.3137 20.0155C12.2153 19.9646 12.1384 19.8914 12.083 19.7959C12.0277 19.7005 12 19.6018 12 19.5C12 19.3982 12.0277 19.2995 12.083 19.2041C12.1384 19.1086 12.2153 19.0354 12.3137 18.9845L14.8967 17.7816L16.0959 15.1468C16.1451 15.0322 16.2159 14.9463 16.3081 14.889C16.4004 14.8317 16.4957 14.8031 16.5941 14.8031C16.6925 14.8031 16.7878 14.8317 16.8801 14.889C16.9723 14.9463 17.0431 15.0259 17.0923 15.1277L18.31 17.7816L20.8745 18.9845C20.9852 19.0354 21.0683 19.1086 21.1236 19.2041C21.179 19.2995 21.2066 19.3982 21.2066 19.5C21.2066 19.6018 21.179 19.7005 21.1236 19.7959C21.0683 19.8914 20.9852 19.9646 20.8745 20.0155L18.31 21.2184L17.0923 23.8723C17.0431 23.9869 16.9723 24.0696 16.8801 24.1205C16.7878 24.1714 16.6925 24.1969 16.5941 24.1969Z" 
    fill="#298BE2"
    />
    </svg>
  )
})


export const GPTversion4Img = createIcon({
  displayName: "GPTversion4Img",
  viewBox: "0 0 24 24",
  path: (
    <svg width="20" height="20" viewBox="0 0 39 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="39" height="39" rx="19.5" fill="#E3F2FF"/>
      <path d="M17.5087 22.0878H14.5617C14.3401 22.0878 14.1761 21.9908 14.0697 21.7967C13.9634 21.6026 13.9787 21.4129 14.1157 21.2276L20.4289 12.2832C20.5224 12.16 20.6394 12.0755 20.7797 12.0297C20.92 11.984 21.0604 11.991 21.2007 12.051C21.341 12.1055 21.4521 12.1971 21.534 12.3258C21.6158 12.4544 21.6451 12.5918 21.6217 12.7379L20.8582 18.6861H24.43C24.6717 18.6861 24.8421 18.7902 24.9412 18.9985C25.0403 19.2067 25.0141 19.4035 24.8627 19.5889L17.908 27.758C17.8144 27.8725 17.6938 27.9469 17.5463 27.9812C17.3987 28.0156 17.262 28.0028 17.1361 27.9428C17.0047 27.8883 16.9031 27.7994 16.8312 27.6762C16.7594 27.553 16.7324 27.4156 16.7502 27.2641L17.5087 22.0878Z" fill="#298BE2"/>
    </svg>
  )
})  


export const ThemeChangeIcon = createIcon({
  displayName: "ThemeChangeIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.95703 18C12.733 18 15.2684 16.737 16.9481 14.6675C17.1966 14.3613 16.9256 13.9141 16.5416 13.9872C12.1751 14.8188 8.16522 11.4709 8.16522 7.06303C8.16522 4.52398 9.52444 2.18914 11.7335 0.931992C12.074 0.738211 11.9884 0.221941 11.6015 0.150469C11.059 0.0504468 10.5086 8.21369e-05 9.95703 0C4.98914 0 0.957031 4.02578 0.957031 9C0.957031 13.9679 4.98281 18 9.95703 18Z" fill="#718096"/>
    </svg>
  )
})


export const InformationIcon = createIcon({
  displayName: "InformationIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 5H11V7H9V5ZM10 15C10.55 15 11 14.55 11 14V10C11 9.45 10.55 9 10 9C9.45 9 9 9.45 9 10V14C9 14.55 9.45 15 10 15ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z" fill="#718096"/>
    </svg>

  )
})

export const EditIcon = createIcon({
  displayName: "editIcon",
  viewBox: "0 0 24 24",
  path: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_5084_312)">
    <path d="M3 17.4596V20.4996C3 20.7796 3.22 20.9996 3.5 20.9996H6.54C6.67 20.9996 6.8 20.9496 6.89 20.8496L17.81 9.93957L14.06 6.18957L3.15 17.0996C3.05 17.1996 3 17.3196 3 17.4596ZM20.71 7.03957C21.1 6.64957 21.1 6.01957 20.71 5.62957L18.37 3.28957C17.98 2.89957 17.35 2.89957 16.96 3.28957L15.13 5.11957L18.88 8.86957L20.71 7.03957Z" fill="#718096"/>
    </g>
    <defs>
    <clipPath id="clip0_5084_312">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
    </svg>
  )
})

export const QuerySendButton = createIcon({
  displayName: "QuerySendButton",
  viewBox: "0 0 28 29",
  path: (
    <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="28" height="28" rx="14" fill="#298BE2"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M14.7071 6.79289C14.3166 6.40237 13.6834 6.40237 13.2929 6.79289L7.79289 12.2929C7.40237 12.6834 7.40237 13.3166 7.79289 13.7071C8.18342 14.0976 8.81658 14.0976 9.20711 13.7071L13 9.91421V21.5C13 22.0523 13.4477 22.5 14 22.5C14.5523 22.5 15 22.0523 15 21.5V9.91421L18.7929 13.7071C19.1834 14.0976 19.8166 14.0976 20.2071 13.7071C20.5976 13.3166 20.5976 12.6834 20.2071 12.2929L14.7071 6.79289Z" fill="white"/>
    </svg>
  )
})

// export const NewChatButton = createIcon({
//   displayName: "NewChatButton",
//   viewBox: "0 0 24 24",
//   path: (
//     <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//       <path d="M21 13V20C21 20.5523 20.5523 21 20 21H4C3.44771 21 3 20.5523 3 20V4C3 3.44771 3.44771 3 4 3H11" stroke="#333333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
//       <path d="M7 13.36V17H10.6586L21 6.65405L17.3475 3L7 13.36Z" stroke="#333333" stroke-width="2" stroke-linejoin="round"/>
//     </svg>
//   )
// })

export const NewChatButton = createIcon({
  displayName: "NewChatButton",
  viewBox: "0 0 25 24",
  path: (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.5 4H7.3C5.61984 4 4.77976 4 4.13803 4.32698C3.57354 4.6146 3.1146 5.07354 2.82698 5.63803C2.5 6.27976 2.5 7.11984 2.5 8.8V17.2C2.5 18.8802 2.5 19.7202 2.82698 20.362C3.1146 20.9265 3.57354 21.3854 4.13803 21.673C4.77976 22 5.61984 22 7.3 22H15.7C17.3802 22 18.2202 22 18.862 21.673C19.4265 21.3854 19.8854 20.9265 20.173 20.362C20.5 19.7202 20.5 18.8802 20.5 17.2V13" stroke="#3C3C3C" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M8.5 14.3255C8.5 13.8363 8.5 13.5917 8.55526 13.3615C8.60425 13.1575 8.68506 12.9624 8.79472 12.7834C8.9184 12.5816 9.09136 12.4086 9.43726 12.0627L19 2.5C19.8285 1.67157 21.1716 1.67157 22 2.5V2.5C22.8285 3.32843 22.8285 4.67157 22 5.5L12.4373 15.0627C12.0914 15.4086 11.9184 15.5816 11.7166 15.7053C11.5377 15.8149 11.3426 15.8957 11.1385 15.9447C10.9083 16 10.6637 16 10.1745 16H8.5V14.3255Z" stroke="#3C3C3C" stroke-opacity="0.3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
})

export const MobileSideBarMenu = createIcon({
  displayName: "MobileSideBarMenu",
  viewBox: "0 0 25 24",
  path:(
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.5 8.5H21.5" stroke="black" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M3.5 15.5H16.5" stroke="black" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  )
})


export const SuggestionsVector = createIcon({
  displayName: "SuggestionsVector",
  viewBox: "0 0 18 21",
  path: (
    <svg width="18" height="21" viewBox="0 0 18 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.64996 17.6067C9.26321 17.9176 8.71531 17.9176 8.32856 17.6067L1.72158 12.2985C1.33483 11.9876 0.797672 11.9876 0.410922 12.2985C-0.136974 12.7427 -0.136974 13.5978 0.410922 14.042L7.67323 19.8832C8.44673 20.5051 9.53178 20.5051 10.316 19.8832L17.5783 14.042C18.1262 13.5978 18.1262 12.7427 17.5783 12.2985L17.5676 12.2874C17.1808 11.9765 16.6437 11.9765 16.2569 12.2874L9.64996 17.6067ZM10.3268 14.253L17.5891 8.4118C18.137 7.9676 18.137 7.10141 17.5891 6.65722L10.3268 0.816017C9.55327 0.19414 8.46822 0.19414 7.68398 0.816017L0.421665 6.66832C-0.126231 7.11252 -0.126231 7.9787 0.421665 8.4229L7.68398 14.2641C8.45748 14.886 9.55327 14.886 10.3268 14.253Z" fill="#718096"/>
    </svg>
  )
})

export const GridGLogo = createIcon({
  displayName:"GridGLogo",
  viewBox:"0 0 78 78",
  path:(
    <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2.13695" y="2.13695" width="73.7261" height="73.7261" rx="36.863" fill="url(#paint0_linear_5224_6115)"/>
      <rect x="2.13695" y="2.13695" width="73.7261" height="73.7261" rx="36.863" stroke="white" stroke-width="4.27391"/>
      <path d="M48.3516 44.8806L39 50.5516L29.8167 45.0741V34.9126L24 31.4287V48.5387L39 57.5001L54 48.5387V37.0611H36.7369L48.3516 44.8806Z" fill="white"/>
      <path d="M37.5714 20L24 28.2965L29.6883 31.7857L37.5714 26.959V20Z" fill="white"/>
      <path d="M40.4287 20V26.959L48.3118 31.7857L54.0001 28.2965L40.4287 20Z" fill="white"/>
      <path d="M48.2169 45L53.9997 48.6235L38.6426 57.5V50.6173L48.2169 45Z" fill="url(#paint1_radial_5224_6115)"/>
      <defs>
      <linearGradient id="paint0_linear_5224_6115" x1="46.5706" y1="64.6941" x2="63.1583" y2="4.73055" gradientUnits="userSpaceOnUse">
      <stop stop-color="#298BE2"/>
      <stop offset="0.927091" stop-color="#1069B8"/>
      </linearGradient>
      <radialGradient id="paint1_radial_5224_6115" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(29.5759 57.1717) scale(7.67857 6.25)">
      <stop offset="0.2222" stop-color="#00004F"/>
      <stop offset="1" stop-color="#32416B" stop-opacity="0"/>
      </radialGradient>
      </defs>
    </svg>
  )
})

export const MobileUserLogo = createIcon({
  displayName:"MobileUserLogo",
  viewBox:"0 0 28 24",
  path:(
    <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="2" width="24" height="24" rx="12" fill="#717171"/>
      <path d="M17.5 12C18.3284 12 19 12.6716 19 13.5V14C19 15.9714 17.1405 18 14 18C10.8595 18 9 15.9714 9 14V13.5C9 12.6716 9.67157 12 10.5 12H17.5ZM14 5.5C15.5188 5.5 16.75 6.73122 16.75 8.25C16.75 9.76878 15.5188 11 14 11C12.4812 11 11.25 9.76878 11.25 8.25C11.25 6.73122 12.4812 5.5 14 5.5Z" fill="white"/>
    </svg>
  )
})

export const UploadImagesChat = createIcon({
  displayName: "uploadImagesChat",
  viewBox:"0 0 16 24",
  path:(
    <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.819 0.00195312C8.37224 0.00195313 6.98474 0.576675 5.96173 1.59969C4.93872 2.6227 4.364 4.0102 4.364 5.45695V15.275C4.364 15.7048 4.44866 16.1304 4.61314 16.5275C4.77763 16.9246 5.01871 17.2854 5.32264 17.5893C5.62657 17.8932 5.98738 18.1343 6.38448 18.2988C6.78158 18.4633 7.20718 18.548 7.637 18.548C8.06682 18.548 8.49242 18.4633 8.88952 18.2988C9.28662 18.1343 9.64743 17.8932 9.95136 17.5893C10.2553 17.2854 10.4964 16.9246 10.6609 16.5275C10.8253 16.1304 10.91 15.7048 10.91 15.275V9.60995C10.8982 9.32867 10.7783 9.06281 10.5751 8.86786C10.372 8.6729 10.1015 8.56392 9.81996 8.56367C9.53843 8.56341 9.26768 8.67189 9.06422 8.86647C8.86075 9.06105 8.7403 9.32669 8.728 9.60795V15.306C8.728 15.5953 8.61306 15.8728 8.40845 16.0774C8.20385 16.282 7.92635 16.397 7.637 16.397C7.34765 16.397 7.07015 16.282 6.86555 16.0774C6.66094 15.8728 6.546 15.5953 6.546 15.306V15.274V15.276V5.45795C6.546 5.02814 6.63066 4.60253 6.79514 4.20543C6.95963 3.80833 7.20071 3.44752 7.50464 3.14359C7.80857 2.83967 8.16938 2.59858 8.56648 2.4341C8.96358 2.26961 9.38918 2.18495 9.819 2.18495C10.2488 2.18495 10.6744 2.26961 11.0715 2.4341C11.4686 2.59858 11.8294 2.83967 12.1334 3.14359C12.4373 3.44752 12.6784 3.80833 12.8429 4.20543C13.0073 4.60253 13.092 5.02814 13.092 5.45795V16.364C13.092 17.8107 12.5173 19.1982 11.4943 20.2212C10.4713 21.2442 9.08376 21.819 7.637 21.819C6.19024 21.819 4.80274 21.2442 3.77973 20.2212C2.75672 19.1982 2.182 17.8107 2.182 16.364V5.42695C2.182 5.1376 2.06706 4.8601 1.86245 4.6555C1.65785 4.4509 1.38035 4.33595 1.091 4.33595C0.801649 4.33595 0.524149 4.4509 0.319546 4.6555C0.114944 4.8601 0 5.1376 0 5.42695V5.45895V5.45695V16.363C4.26778e-08 18.3881 0.804505 20.3304 2.23653 21.7624C3.66856 23.1944 5.61081 23.999 7.636 23.999C9.66119 23.999 11.6034 23.1944 13.0355 21.7624C14.4675 20.3304 15.272 18.3881 15.272 16.363V5.45695C15.2707 4.0106 14.6955 2.62387 13.6728 1.60115C12.6501 0.578424 11.2634 0.00327702 9.817 0.00195313L9.819 0.00195312Z" fill="black"/>
    </svg>
  )
})

export const MobileImgUpload = createIcon({
  displayName:"MobileImgUpload",
  viewBox:"0 0 30 24",
  path:(
    <svg width="30" height="28" viewBox="0 0 30 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" width="28" height="28" rx="14" fill="white"/>
      <path d="M23 14C23 14.5523 22.5523 15 22 15H16V21C16 21.5523 15.5523 22 15 22C14.4477 22 14 21.5523 14 21V15H8C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13H14V7C14 6.44772 14.4477 6 15 6C15.5523 6 16 6.44772 16 7V13H22C22.5523 13 23 13.4477 23 14Z" fill="#717171"/>
    </svg>
  )
})

export const MobileVoiceUpload = createIcon({
  displayName:"MobileVoiceUpload",
  viewBox:"0 0 24 24",
  path:(
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C12.5523 2 13 2.44772 13 3L13 21C13 21.5523 12.5523 22 12 22C11.4477 22 11 21.5523 11 21L11 3C11 2.44772 11.4477 2 12 2ZM8 5C8.55228 5 9 5.44772 9 6V19C9 19.5523 8.55228 20 8 20C7.44772 20 7 19.5523 7 19V6C7 5.44772 7.44772 5 8 5ZM4 9C4.55228 9 5 9.44772 5 10V15.5C5 16.0523 4.55228 16.5 4 16.5C3.44772 16.5 3 16.0523 3 15.5V10C3 9.44772 3.44772 9 4 9ZM17 6C17 5.44772 16.5523 5 16 5C15.4477 5 15 5.44772 15 6V19C15 19.5523 15.4477 20 16 20C16.5523 20 17 19.5523 17 19V6ZM21 10C21 9.44772 20.5523 9 20 9C19.4477 9 19 9.44772 19 10V15.5C19 16.0523 19.4477 16.5 20 16.5C20.5523 16.5 21 16.0523 21 15.5V10Z" fill="#AAAAAA"/>
    </svg>
  )
})

export const ImgCrossIcon = createIcon({
  displayName:"ImgCrossIcon",
  viewBox:"0 0 18 18",
  path:(
    <svg width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="7.5" fill="#545454" fill-opacity="1" stroke="#545454"/>
      <path d="M8.70497 8.00009L10.855 5.85509C10.9491 5.76094 11.002 5.63324 11.002 5.50009C11.002 5.36694 10.9491 5.23924 10.855 5.14509C10.7608 5.05094 10.6331 4.99805 10.5 4.99805C10.3668 4.99805 10.2391 5.05094 10.145 5.14509L7.99997 7.29509L5.85497 5.14509C5.76082 5.05094 5.63312 4.99805 5.49997 4.99805C5.36682 4.99805 5.23912 5.05094 5.14497 5.14509C5.05082 5.23924 4.99792 5.36694 4.99792 5.50009C4.99792 5.63324 5.05082 5.76094 5.14497 5.85509L7.29497 8.00009L5.14497 10.1451C5.09811 10.1916 5.06091 10.2469 5.03552 10.3078C5.01014 10.3687 4.99707 10.4341 4.99707 10.5001C4.99707 10.5661 5.01014 10.6315 5.03552 10.6924C5.06091 10.7533 5.09811 10.8086 5.14497 10.8551C5.19145 10.902 5.24675 10.9392 5.30768 10.9645C5.36861 10.9899 5.43396 11.003 5.49997 11.003C5.56598 11.003 5.63133 10.9899 5.69226 10.9645C5.75319 10.9392 5.80849 10.902 5.85497 10.8551L7.99997 8.70509L10.145 10.8551C10.1915 10.902 10.2468 10.9392 10.3077 10.9645C10.3686 10.9899 10.434 11.003 10.5 11.003C10.566 11.003 10.6313 10.9899 10.6923 10.9645C10.7532 10.9392 10.8085 10.902 10.855 10.8551C10.9018 10.8086 10.939 10.7533 10.9644 10.6924C10.9898 10.6315 11.0029 10.5661 11.0029 10.5001C11.0029 10.4341 10.9898 10.3687 10.9644 10.3078C10.939 10.2469 10.9018 10.1916 10.855 10.1451L8.70497 8.00009Z" 
      fill="white"/>
    </svg>
  )
})